<script lang="ts">
    import { SidebarInset } from '@/components/ui/sidebar';
    import type { Snippet } from 'svelte';
    import {meta} from "@/meta.svelte";

    type Props = {
        variant?: 'header' | 'sidebar';
        class?: string;
        children: Snippet;
    };

    let { variant, class: className, csrfToken = '', children }: Props = $props();


</script>

{#if variant === 'sidebar'}
    <SidebarInset class={className}>
        <div class="mx-auto w-full max-w-7xl">
            {@render children?.()}
        </div>
    </SidebarInset>
{:else}
    <main class="flex h-full mx-2 md:mx-8 lg:mx-16 xl:mx-32 flex-1 flex-col gap-4 p-4 rounded-xl {className}">
        {@render children?.()}
    </main>
{/if}
